import { useTranslation } from "react-i18next";
import { InputWithAlert } from "@/components/ui/input-with-alert";

const formatNumber = (value) => {
  const num = parseFloat(value) || 0;
  return num.toFixed(2);
};

const formatDiff = (value) => {
  const num = parseFloat(value) || 0;
  const formatted = num.toFixed(2);
  return num > 0 ? `+${formatted}` : formatted;
};

export const CorrectionSummarySection = ({ form }) => {
  const { t } = useTranslation();
  const { totals, originalInvoice } = form;

  const currency = originalInvoice?.paymentCurrency || 'PLN';

  return (
    <div className='w-full'>
      <div className="w-full text-xl font-medium py-6">
        {t('invoices:correction_summary')}
      </div>

      {/* Netto row */}
      <div className='w-full flex justify-between flex-wrap'>
        <div className='w-full md:w-1/3 pr-2'>
          <InputWithAlert
            label={`${t("invoices:before_value")} ${t("invoices:price_netto")}`}
            value={`${formatNumber(totals.beforeNetto)} ${currency}`}
            readOnly={true}
            disabled
            inputClassName={'h-12 mt-2 mb-4 bg-white'}
          />
        </div>
        <div className='w-full md:w-1/3 pr-2'>
          <InputWithAlert
            label={`${t("invoices:after_value")} ${t("invoices:price_netto")}`}
            value={`${formatNumber(totals.afterNetto)} ${currency}`}
            readOnly={true}
            disabled
            inputClassName={'h-12 mt-2 mb-4 bg-white'}
          />
        </div>
        <div className='w-full md:w-1/3'>
          <InputWithAlert
            label={`${t("invoices:diff_value")} ${t("invoices:price_netto")}`}
            value={`${formatDiff(totals.diffNetto)} ${currency}`}
            readOnly={true}
            disabled
            inputClassName={`h-12 mt-2 mb-4 bg-white ${totals.diffNetto > 0 ? 'text-green-600' : totals.diffNetto < 0 ? 'text-red-600' : ''}`}
          />
        </div>
      </div>

      {/* VAT row */}
      <div className='w-full flex justify-between flex-wrap'>
        <div className='w-full md:w-1/3 pr-2'>
          <InputWithAlert
            label={`${t("invoices:before_value")} VAT`}
            value={`${formatNumber(totals.beforeVat)} ${currency}`}
            readOnly={true}
            disabled
            inputClassName={'h-12 mt-2 mb-4 bg-white'}
          />
        </div>
        <div className='w-full md:w-1/3 pr-2'>
          <InputWithAlert
            label={`${t("invoices:after_value")} VAT`}
            value={`${formatNumber(totals.afterVat)} ${currency}`}
            readOnly={true}
            disabled
            inputClassName={'h-12 mt-2 mb-4 bg-white'}
          />
        </div>
        <div className='w-full md:w-1/3'>
          <InputWithAlert
            label={`${t("invoices:diff_value")} VAT`}
            value={`${formatDiff(totals.diffVat)} ${currency}`}
            readOnly={true}
            disabled
            inputClassName={`h-12 mt-2 mb-4 bg-white ${totals.diffVat > 0 ? 'text-green-600' : totals.diffVat < 0 ? 'text-red-600' : ''}`}
          />
        </div>
      </div>

      {/* Brutto row */}
      <div className='w-full flex justify-between flex-wrap'>
        <div className='w-full md:w-1/3 pr-2'>
          <InputWithAlert
            label={`${t("invoices:before_value")} ${t("invoices:price_brutto")}`}
            value={`${formatNumber(totals.beforeBrutto)} ${currency}`}
            readOnly={true}
            disabled
            inputClassName={'h-12 mt-2 mb-4 bg-white font-bold'}
          />
        </div>
        <div className='w-full md:w-1/3 pr-2'>
          <InputWithAlert
            label={`${t("invoices:after_value")} ${t("invoices:price_brutto")}`}
            value={`${formatNumber(totals.afterBrutto)} ${currency}`}
            readOnly={true}
            disabled
            inputClassName={'h-12 mt-2 mb-4 bg-white font-bold'}
          />
        </div>
        <div className='w-full md:w-1/3'>
          <InputWithAlert
            label={`${t("invoices:diff_value")} ${t("invoices:price_brutto")}`}
            value={`${formatDiff(totals.diffBrutto)} ${currency}`}
            readOnly={true}
            disabled
            inputClassName={`h-12 mt-2 mb-4 bg-white font-bold ${totals.diffBrutto > 0 ? 'text-green-600' : totals.diffBrutto < 0 ? 'text-red-600' : ''}`}
          />
        </div>
      </div>
    </div>
  );
};
